import {connect} from "react-redux";
import actions from 'actions';
import AdminHistory from "../Pages/AdminHistory/AdminHistory";

const mapStateToProps = (state)=> {
  return {
    user: state.current && state.current.user,
    company: state.company && state.company.company
  }
};

const mapDispatchToProps = dispatch => {
  return {
    getAdminHistories:(aUserId, aUpToDate, aFromDate, aLimit, aOffset, aPatientIdOrEdcId, aItemType, aItemId) => {
      return dispatch(actions.getAdminHistories(aUserId, aUpToDate, aFromDate, aLimit, aOffset, aPatientIdOrEdcId, aItemType, aItemId));
    }
  };
};
export default connect(mapStateToProps,mapDispatchToProps)(AdminHistory);
